<template>
  <v-row justify="center">
    <v-dialog v-model="deleteConfirmDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">削除しますか？</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="deleteConfirmDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="deleteMarker">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <CreateMarkerDialog v-model="openEditDialog" 
                        :marker="marker"
                        :isEdit="true"
                        @updated="open=false"/>

    <v-dialog v-model="open" max-width="800px">
      <v-card id=container>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">{{(marker && marker.createdBy)?marker.createdBy.name:''}}</div>
            <v-list-item-title class="headline mb-1">{{marker.title?marker.title:'[ untitled ]'}}</v-list-item-title>
            
          </v-list-item-content>

          <v-list-item-avatar tile size="80" color="grey">
            <img :src='marker?marker.markerImage:"marker"'/>
          </v-list-item-avatar>
        </v-list-item>

        <v-card-text class="content" v-html='marker?marker.description:""' />
        <template v-if='havePrivateContent' >
          <v-card style='background:red; color:black; margin:25px 15px;'>
            <v-card-title style='background:red; color:#00000099;'>
              Secret {{isOwner?'(あなたは作成者です)':''}}{{isAdmin?'(あなたは管理者です)':''}}
            </v-card-title>
            <v-card-text style='' class="content private-content" :class="{'hidden-private-content':!isBrowsablePrivateContent}" v-html='privateContent' />
          </v-card>
        </template>
        <v-card-actions v-if="isEditable && !$store.state.siteClosed">
          <v-spacer/>
          <v-btn color="red darken-1" text @click="deleteConfirmDialog=true">Delete</v-btn>
          <v-spacer/>
          <v-btn color="gray darken-1" text @click="editMarker">Edit</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
//TODO: move this on store.
import {db} from '@/firebase'
import CreateMarkerDialog from '@/components/CreateMarkerDialog'

export default {
  name: 'MarkerInfoWindow',
  components: {CreateMarkerDialog},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    marker: {
      type: Object,
      default: () => {}
    },
  },
  data: function() {
    return {
      openEditDialog: false,
      deleteConfirmDialog: false,
    };
  },
  computed: {
    privateContent() {
      if (this.isBrowsablePrivateContent) {
        return this.marker?this.marker.description_private:""
      } else {
        const dummy = '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>'.repeat(1); 
        return dummy;
      }
    },
    isBrowsablePrivateContent() {
      return this.isAdmin || this.isOwner;
    },
    havePrivateContent() {
      if (this.marker.description_private == undefined) {
        return false;
      }
      const planeText = 
        this.marker.description_private
        .replace(/<iframe("[^"]*"|'[^']*'|[^'">])*>/g, 'IFRAME')
        .replace(/<img("[^"]*"|'[^']*'|[^'">])*>/g, 'IMG')
        .replace(/<("[^"]*"|'[^']*'|[^'">])*>|\s/g, '');
      return Boolean(planeText);
    },
    isPublic() {
      //return this.marker.public != undefined ? this.marker.public : true;
      return true;
    },
    isBrowsable() {
      return this.isAdmin || this.isOwner || this.isPublic;
    },
    isOwner() {
      return (this.marker.createdBy) && (this.marker.createdBy.authUid == this.$store.getters.loginId);
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isEditable() {
      try {
        return this.isAdmin || this.isOwner;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    open: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    updateMarker() {
      console.log("Test code!!!")
      this.marker.title = "updated!!!"
      db.collection('markers')
        .doc(this.marker.id)
        .set(this.marker)
        .then(() => {
          console.log('user updated!')
        })
    },
    editMarker() {
      this.openEditDialog = true;
    },
    deleteMarker() {
      const that = this;
      db.collection('markers')
        .doc(this.marker.id)
        .delete()
        .then(() => {
          that.deleteConfirmDialog = false;
          that.open = false;
        });
    }
  },
}
</script>

<style>
.v-dialog {
  background: black;
}
</style>

<style scoped>
#container {
  background: black;
}
#container *{
  color: red;
}

.content >>> * {
  max-width: 100%;
}

.private-content {
  background:red !important;
  color:black !important;
}

.hidden-private-content {
  color:black !important;
  /* background: -webkit-linear-gradient(270deg,black, red) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important; */
  -ms-filter: blur(3px);
  -webkit-filter: blur(3px);
  filter: blur(3px);
  -ms-user-select: none;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
</style>
